/* SHELONGZ mobile menu (I.AM.GIA style) – phones only (<750px). Falls back to the theme menu if anything is missing. */
(function () {
  var MQ = window.matchMedia('(max-width: 749px)');
  var D = window.SLZ_MM;
  if (!D || !D.l || !D.l.length) return;

  var CSS = '' +
    '@media (max-width:749px){' +
    '.slz-mm-on .menu-drawer__navigation{display:none!important}' +
    '.slz-mm,.slz-mm *{font-family:"Helvetica Neue",Helvetica,Arial,sans-serif!important}' +
    '.slz-mm{color:#000;width:100%;flex:1 1 auto!important;min-height:0;overflow-x:hidden;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;-webkit-font-smoothing:antialiased}' +
    '.slz-mm-on .menu-drawer__featured-content{display:none!important}' +
    '.slz-mm-on.menu-drawer{top:var(--slz-top,0px)!important;height:calc(100dvh - var(--slz-vt,0px))!important;width:100vw!important;max-width:100vw!important;border:0!important;box-shadow:none!important;padding-top:6px!important}' +
    '.slz-mm-on .menu-drawer__close-button,.slz-mm-on > button[on\\:click="/close"]{display:none!important}' +
    'details.slz-mm-d .menu-drawer__backdrop{display:none!important}' +
    'html.slz-mm-open #header-component,html.slz-mm-open header-component,html.slz-mm-open .header__row,html.slz-mm-open .header{background:#fff!important;background-color:#fff!important}' +
    'html.slz-mm-open #header-component *,html.slz-mm-open header-component *{color:#000!important}' +
    'html.slz-mm-open #header-component .cart-bubble,html.slz-mm-open #header-component .cart-bubble *,html.slz-mm-open header-component .cart-bubble *{color:#fff!important}' +
    '.slz-mm *{box-sizing:border-box}' +
    '.slz-mm-panels{display:flex;width:200%;align-items:flex-start;transition:transform .32s cubic-bezier(.4,0,.2,1)}' +
    '.slz-mm.is-sub .slz-mm-panels{transform:translateX(-50%)}' +
    '.slz-mm-panel{width:50%;flex:0 0 50%;padding:0 0 28px}' +
    '.slz-mm-search{display:flex;align-items:center;background:#ececec;height:44px;padding:0 12px 0 8px;margin:0 0 10px}' +
    '.slz-mm-search input{flex:1;min-width:0;border:0!important;outline:0!important;box-shadow:none!important;background:transparent!important;padding:0!important;margin:0;height:100%;font-size:17px!important;font-weight:500!important;line-height:1!important;letter-spacing:-.2px!important;text-transform:uppercase;color:#000!important;-webkit-appearance:none;appearance:none;border-radius:0}' +
    '.slz-mm-search input::placeholder{color:#000;opacity:1}' +
    '.slz-mm-search input::-webkit-search-cancel-button{display:none}' +
    '.slz-mm-search button{border:0;background:none;padding:4px;margin:0;display:flex;align-items:center;color:#000;cursor:pointer}' +
    '.slz-mm-list{list-style:none;margin:0;padding:0 8px}' +
    '.slz-mm-list li{margin:0 0 4px;padding:0}' +
    '.slz-mm-item{display:flex;align-items:center;gap:12px;width:100%;padding:0;margin:0;border:0;background:none;text-align:left;color:#000!important;text-decoration:none!important;cursor:pointer;-webkit-tap-highlight-color:transparent}' +
    '.slz-mm-thumb{flex:0 0 60px;width:60px;height:66px;object-fit:cover;display:block;background:#eee}' +
    '.slz-mm-title{font-size:32px;font-weight:700;line-height:1.02;letter-spacing:-1.3px;text-transform:uppercase;word-break:break-word}' +
    '.slz-mm-arrow{display:inline-block;font-size:19px;font-weight:400;letter-spacing:0;margin-left:9px;vertical-align:middle;position:relative;top:-2px}' +
    '.slz-mm-back{display:flex;align-items:center;gap:12px;border:0;background:none;padding:6px 8px 40px;margin:0;color:#000;font-size:16px;font-weight:500;letter-spacing:-.2px;text-transform:uppercase;cursor:pointer;-webkit-tap-highlight-color:transparent}' +
    '.slz-mm-back svg{flex:0 0 auto}' +
    '.slz-mm-sub{list-style:none;margin:0;padding:0 8px}' +
    '.slz-mm-sub li{margin:0;padding:0}' +
    '.slz-mm-sub a{display:block;padding:2px 0;color:#000!important;text-decoration:none!important;font-size:20px;font-weight:500;line-height:1.3;letter-spacing:-.4px;text-transform:uppercase;-webkit-tap-highlight-color:transparent}' +
    '}' +
    '@media (min-width:750px){.slz-mm{display:none!important}}';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var ICON_SEARCH = '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="10.5" cy="10.5" r="7"/><path d="M15.8 15.8L21 21" stroke-linecap="round"/></svg>';
  var ICON_BACK = '<svg width="22" height="16" viewBox="0 0 22 16" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M21 8H2M8.5 1.5L2 8l6.5 6.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function pickImages() {
    var used = {};
    D.l.forEach(function (l) {
      var list = Array.isArray(l.i) ? l.i.filter(Boolean) : (l.i ? [l.i] : []);
      for (var j = list.length - 1; j > 0; j--) { var r = Math.floor(Math.random() * (j + 1)); var tmp = list[j]; list[j] = list[r]; list[r] = tmp; }
      var pick = '';
      for (var k = 0; k < list.length; k++) { var key = list[k].split('?')[0]; if (!used[key]) { pick = list[k]; used[key] = 1; break; } }
      if (!pick && list.length) pick = list[0];
      l.img = pick;
    });
  }

  function build() {
    pickImages();
    var mainItems = D.l.map(function (l, i) {
      var thumb = l.img ? '<img class="slz-mm-thumb" src="' + esc(l.img) + '" alt="" loading="lazy" width="60" height="66">' : '<span class="slz-mm-thumb"></span>';
      var has = l.c && l.c.length;
      var title = '<span class="slz-mm-title">' + esc(l.t) + (has ? '<span class="slz-mm-arrow" aria-hidden="true">&rarr;</span>' : '') + '</span>';
      if (has) return '<li><button type="button" class="slz-mm-item" data-slz-open="' + i + '" aria-haspopup="true">' + thumb + title + '</button></li>';
      return '<li><a class="slz-mm-item" href="' + esc(l.u) + '">' + thumb + title + '</a></li>';
    }).join('');

    var root = document.createElement('div');
    root.className = 'slz-mm';
    root.innerHTML =
      '<div class="slz-mm-panels">' +
        '<div class="slz-mm-panel slz-mm-main">' +
          '<form class="slz-mm-search" action="' + esc(D.r || '/search') + '" method="get" role="search">' +
            '<input type="search" name="q" placeholder="' + esc(D.s || 'SEARCH') + '" aria-label="' + esc(D.s || 'Search') + '" autocomplete="off">' +
            '<button type="submit" aria-label="' + esc(D.s || 'Search') + '">' + ICON_SEARCH + '</button>' +
          '</form>' +
          '<ul class="slz-mm-list">' + mainItems + '</ul>' +
        '</div>' +
        '<div class="slz-mm-panel slz-mm-subpanel" aria-hidden="true"></div>' +
      '</div>';
    return root;
  }

  function openSub(root, i) {
    var l = D.l[i];
    if (!l) return;
    var sub = root.querySelector('.slz-mm-subpanel');
    var links = (D.va ? '<li><a href="' + esc(l.u) + '">' + esc(D.va) + '</a></li>' : '') +
      l.c.map(function (c) { return '<li><a href="' + esc(c.u) + '">' + esc(c.t) + '</a></li>'; }).join('');
    sub.innerHTML = '<button type="button" class="slz-mm-back" data-slz-back>' + ICON_BACK + '<span>' + esc(l.t) + '</span></button><ul class="slz-mm-sub">' + links + '</ul>';
    sub.setAttribute('aria-hidden', 'false');
    root.querySelector('.slz-mm-main').setAttribute('aria-hidden', 'true');
    root.classList.add('is-sub');
    root.scrollTop = 0;
    var drawer = root.closest('.menu-drawer');
    if (drawer) drawer.scrollTop = 0;
  }

  function closeSub(root) {
    root.classList.remove('is-sub');
    root.querySelector('.slz-mm-main').setAttribute('aria-hidden', 'false');
    root.querySelector('.slz-mm-subpanel').setAttribute('aria-hidden', 'true');
  }

  function place(details) {
    if (!MQ.matches || !details) return;
    var drawer = details.querySelector('.slz-mm-on');
    var sum = details.querySelector('summary');
    if (!drawer || !sum) return;
    var row = sum.closest('.header__row') || sum.closest('header, #header-component') || sum;
    var bottom = Math.max(0, Math.round(row.getBoundingClientRect().bottom));
    drawer.style.setProperty('--slz-top', '0px');
    var base = drawer.getBoundingClientRect().top;
    drawer.style.setProperty('--slz-top', (bottom - base) + 'px');
    drawer.style.setProperty('--slz-vt', bottom + 'px');
  }

  function attach(nav) {
    var drawer = nav.closest('.menu-drawer') || nav.parentNode;
    var prev = nav.previousElementSibling;
    if (prev && prev.classList && prev.classList.contains('slz-mm')) { drawer.classList.add('slz-mm-on'); return; }
    var root = build();
    nav.parentNode.insertBefore(root, nav);
    drawer.classList.add('slz-mm-on');
    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-slz-open]');
      if (o) { e.preventDefault(); e.stopPropagation(); openSub(root, +o.getAttribute('data-slz-open')); return; }
      if (e.target.closest('[data-slz-back]')) { e.preventDefault(); e.stopPropagation(); closeSub(root); }
    });
    var details = drawer.closest('details');
    if (details) { details.classList.add('slz-mm-d'); place(details); }
    if (details && !details.__slzmm) {
      details.__slzmm = 1;
      details.addEventListener('toggle', function () {
        document.documentElement.classList.toggle('slz-mm-open', !!details.open);
        if (details.open) place(details);
        if (!details.open) setTimeout(function () { var r = details.querySelector('.slz-mm'); if (r) closeSub(r); }, 350);
      });
    }
    try { console.info('[slz-mm] v7 mounted'); } catch (e) {}
  }

  function mount() {
    if (!MQ.matches) return;
    if (!document.getElementById('slz-mm-css')) {
      var st = document.createElement('style');
      st.id = 'slz-mm-css';
      st.textContent = CSS;
      (document.head || document.documentElement).appendChild(st);
    }
    var navs = document.querySelectorAll('.menu-drawer__navigation');
    for (var i = 0; i < navs.length; i++) {
      if (navs[i].closest('header-drawer, .header-drawer, .header__drawer, #header-component')) attach(navs[i]);
    }
  }

  var queued = 0;
  function schedule() {
    if (queued) return;
    queued = 1;
    (window.requestAnimationFrame || setTimeout)(function () { queued = 0; try { mount(); } catch (e) {} });
  }

  function init() {
    try { mount(); } catch (e) {}
    try { new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
    document.addEventListener('click', function (e) { var sm = e.target.closest && e.target.closest('summary'); if (sm) { schedule(); var d = sm.closest('details.slz-mm-d'); if (d) { place(d); setTimeout(function () { place(d); }, 60); } } }, true);
    window.addEventListener('resize', function () { var d = document.querySelectorAll('details.slz-mm-d[open]'); for (var i = 0; i < d.length; i++) place(d[i]); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (MQ.addEventListener) MQ.addEventListener('change', schedule);
})();
